import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowWrapping1cfo2cqk4jxme as RowWrapping,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  User3mqs8plvl8nwo as User,
  get_entries208xk6b864p6f as get_entries,
  UserRole_User_getInstance3eetxpzgtepd2 as UserRole_User_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  get_notNull2od35hy6ssmdh as get_notNull,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name3aern4pcdmrjz as get_name,
  get_phoneph41zjp0zq4b as get_phone,
  get_preferredLanguage2fe7014lb3h3h as get_preferredLanguage,
  get_role1nin6e4oapglm as get_role,
  get_managesEmployerscxv9xf6aqew1 as get_managesEmployers,
  get_managesProviders1061ox89jyaox as get_managesProviders,
  get_managesLocations32fghveu592vx as get_managesLocations,
  get_managesFamiliesqhp25q3m346r as get_managesFamilies,
  get_name3gijmx3xstqlj as get_name_0,
  get_name27z06mu1petol as get_name_1,
  get_name29bc1mdqu6171 as get_name_2,
  get_primaryParent1y63p7tb3kpdx as get_primaryParent,
  get_lastName3bf5kvm2i63yd as get_lastName,
  get_secondaryParent11vqc6r832a2n as get_secondaryParent,
  get_address2uhm0456nbriz as get_address,
  get_city182djzl8rp5cw as get_city,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import {
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  toEmailAddress1e4w5ykg7qyos as toEmailAddress,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import {
  reactiveLabel206b3aonybuoa as reactiveLabel,
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
} from '../components/view-utilities.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  LabeledViewseav57tyecmf as LabeledView,
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { withStringBuffer3khj76irczpue as withStringBuffer } from '../components/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atCenterEnd393qzfpu2gjbc as get_atCenterEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  h2ld0l0a2c9zpb as h2,
  subtext2yjmf1ok7kb40 as subtext,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
  BannerSemantic_getInstance18p0b4btg61q8 as BannerSemantic_getInstance,
  styledHeaderwng1nfqibdig as styledHeader,
} from '../../theme/semantics.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { filterChip1bkihjb9h4931 as filterChip } from '../components/filters.mjs';
import { renderList2ygesqkknbufi as renderList } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/foreach.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Metadata2mqfolh2et60e as Metadata } from '../../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { handleException14reyfdad0gfg as handleException } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementContext.mjs';
import { multiSelectAddButton23vne58r85kkf as multiSelectAddButton } from '../components/multiSelectAddButton.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { UserDetailPage3cz18tdewf15f as UserDetailPage } from './UserDetailPage.mjs';
import {
  IDqqik72jjbpsn as ID,
  Employer27b20p5x27kte as Employer,
  ID1m87d1hextx54 as ID_0,
  CareProvider2qcawrqluyllr as CareProvider,
  ID1z61wlmtvxrjn as ID_1,
  CareLocation1v3u5wduz023s as CareLocation,
  IDjecfjjw6mot9 as ID_2,
  Family2k7vz7ddyergb as Family,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { xDataClassPathContainsCased3loynnz3n7tb9 as xDataClassPathContainsCased } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { or1uh2qn0k1rz6c as or } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { minus27abgkurcn6u0 as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function userForm(form, _this__u8e3s4, user, emailEditable) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  var tmp = userForm$lambda;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$8 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$8);
  var tmp$ret$9 = get_name(it);
  var tmp$ret$6 = lensPath(user, tmp$ret$9);
  form.stringField$default_pwglgw_k$(element, tmp, assertNotBlank(tmp$ret$6), true);
  if (emailEditable) {
    var tmp_1 = userForm$lambda_0;
    var tmp_2 = userForm$lambda_1;
    form.emailField$default_lqqr0_k$(element, tmp_1, user.lens_u4wb4z_k$(tmp_2, userForm$lambda_2), true);
  } else {
    var tmp_3 = userForm$lambda_3;
    reactiveLabel(element, tmp_3, ($this$reactiveLabel) => EmailAddress__toString_impl_artjh3($this$reactiveLabel.invoke_r7m7el_k$(user).email_1));
  }
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  var tmp_4 = KMutableProperty0();
  var tmp_5 = LabeledView$_get_content_$ref_5yojet(element_0);
  var tmp_6 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, LabeledView$_set_content_$ref_ys1c8f(element_0));
  element_0.invoke_bnq13k_k$(tmp_6, userForm$lambda_4);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
  var this_0 = themed(element_0, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = PhoneNumberInput().new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_w1yrw4_k$(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_0.willAddChild_hz2iwc_k$(element_1);
  var tmp_7 = element_1.get_content_h02jrk_k$();
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_8 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$19 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$19);
  var tmp$ret$20 = get_phone(it_0);
  var tmp$ret$17 = lensPath(user, tmp$ret$20);
  element_1.bind_gesskf_k$(tmp_7, withStringBuffer(validated(tmp$ret$17)));
  element_1.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element.willAddChild_hz2iwc_k$(element_2);
  var tmp_9 = KMutableProperty0();
  var tmp_10 = LabeledView$_get_content_$ref_5yojet(element_2);
  var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, LabeledView$_set_content_$ref_ys1c8f(element_2));
  element_2.invoke_bnq13k_k$(tmp_11, userForm$lambda_5);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_1 = themed(element_2, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (TextInput())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_1.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_12 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$30 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$30);
  var tmp$ret$31 = get_preferredLanguage(it_1);
  var tmp$ret$28 = lensPath(user, tmp$ret$31);
  element_3.bind_gesskf_k$(element_3.content_1, tmp$ret$28);
  element_3.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_3);
  element_2.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_2);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function addUserDialog(form, _this__u8e3s4, user, clearDraft) {
  // Inline function 'kotlin.with' call
  var $this$with = form;
  dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, addUserDialog$lambda$lambda);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    userForm($this$with, element, user, true);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(element_2, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
    element_4.invoke_bnq13k_k$(tmp_4, addUserDialog$lambda$lambda_0);
    element_4.onStartup_vrxh3i_k$();
    element_3.addChild_2qpft2_k$(element_4);
    onClick(element_3, VOID, VOID, VOID, addUserDialog$lambda$slambda(user, close));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_2 = weight(element_2, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Space())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_3 = themed(element_2, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(this_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_4.willAddChild_hz2iwc_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element_6.willAddChild_hz2iwc_k$(element_7);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_7);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_7));
    element_7.invoke_bnq13k_k$(tmp_7, addUserDialog$lambda$lambda_1);
    element_7.onStartup_vrxh3i_k$();
    element_6.addChild_2qpft2_k$(element_7);
    element_6.set_action_2ds022_k$(Action('Add user', VOID, VOID, VOID, VOID, VOID, addUserDialog$lambda$slambda_0(user, $this$with, element_6, close, clearDraft)));
    element_6.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_6);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return Unit_instance;
}
function userPermissions(_this__u8e3s4, editMode, user, employers, providers, locations, families) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_0 = get_centered(element_0);
  var tmp$ret$8 = weight(this_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = themed(tmp$ret$8, LabelGapSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  h2(element_1, 'Role and permissions');
  subtext(element_1, 'What this account can see and edit. Add only what they need for their work.');
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_2 = themed(element, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  element_2.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_3 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(editMode));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (RowOrCol())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  element_3.set_vertical_nuap32_k$(false);
  text(get_bold(get_centered(element_3)), 'Access Role:');
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_4 = themed(get_centered(element_3), ChipSemantic_getInstance().plus_duvq05_k$(ImportantSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_4.willAddChild_hz2iwc_k$(element_4);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return $this$invoke.invoke_r7m7el_k$(user).role_1.displayName_1.toUpperCase();
  });
  element_4.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_4);
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_5 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(editMode));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (RowOrCol())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  this_5.willAddChild_hz2iwc_k$(element_5);
  element_5.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_5.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  element_5.willAddChild_hz2iwc_k$(element_6);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = LabeledView$_get_content_$ref_5yojet(element_6);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, LabeledView$_set_content_$ref_ys1c8f(element_6));
  element_6.invoke_bnq13k_k$(tmp_4, userPermissions$lambda);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  var this_6 = themed(element_6, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = new (Select())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  this_6.willAddChild_hz2iwc_k$(element_7);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_5 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$40 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$40);
  var tmp$ret$41 = get_role(it);
  var tmp_6 = lensPath(user, tmp$ret$41);
  var tmp_7 = _Constant___init__impl__v45mub(toList(get_entries()));
  element_7.bind_64a41i_k$(tmp_6, new (Constant())(tmp_7), userPermissions$lambda_0);
  element_7.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_7);
  element_6.onStartup_vrxh3i_k$();
  element_5.addChild_2qpft2_k$(element_6);
  element_5.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_5);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var this_7 = themed(element_2, BannerSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_8 = themed(this_7, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = new (TextView())(this_8.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  this_8.willAddChild_hz2iwc_k$(element_8);
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_8);
  var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_8));
  element_8.invoke_bnq13k_k$(tmp_10, ($this$invoke) => {
    var tmp;
    switch ($this$invoke.invoke_r7m7el_k$(user).role_1.ordinal_1) {
      case 1:
        tmp = 'Sees only what is explicitly granted below. With no grants, they see nothing.';
        break;
      case 2:
        tmp = 'TCG staff role. Sees and manages everything.';
        break;
      case 0:
        tmp = 'No permissions.';
        break;
      case 3:
      case 4:
        tmp = 'Unrestricted access. Use sparingly.';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  });
  element_8.onStartup_vrxh3i_k$();
  this_8.addChild_2qpft2_k$(element_8);
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_9 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(user).role_1.equals(UserRole_User_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (RowOrCol())(this_9.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  this_9.willAddChild_hz2iwc_k$(element_9);
  element_9.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = new (Space())(element_9.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  element_9.willAddChild_hz2iwc_k$(element_10);
  element_10.onStartup_vrxh3i_k$();
  element_9.addChild_2qpft2_k$(element_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_11 = new (RowOrCol())(element_9.get_context_h02k06_k$());
  ensureOutermostElement(element_11);
  element_9.willAddChild_hz2iwc_k$(element_11);
  element_11.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_11 = weight(element_11, 1.0);
  styledHeader(tmp_11, userPermissions$lambda_1);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_12 = weight(element_11, 1.0);
  styledHeader(tmp_12, userPermissions$lambda_2);
  element_11.onStartup_vrxh3i_k$();
  element_9.addChild_2qpft2_k$(element_11);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_12 = new (Separator())(element_9.get_context_h02k06_k$());
  ensureOutermostElement(element_12);
  element_9.willAddChild_hz2iwc_k$(element_12);
  element_12.onStartup_vrxh3i_k$();
  element_9.addChild_2qpft2_k$(element_12);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_13 = new (RowOrCol())(element_9.get_context_h02k06_k$());
  ensureOutermostElement(element_13);
  element_9.willAddChild_hz2iwc_k$(element_13);
  element_13.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_13 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$69 = isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$69);
  var tmp$ret$70 = get_managesEmployers(it_0);
  var tmp_14 = lensPath(user, tmp$ret$70);
  var tmp_15 = userPermissions$lambda_3;
  var tmp_16 = userPermissions$lambda_4;
  var tmp_17 = userPermissions$lambda_5;
  var tmp_18 = userPermissions$lambda_6;
  managedEntitySection(element_13, 'Employers', "Edit the employer's own record; read-only on their rates, balance, and family authorizations. (Children stay with Families, below.)", employers, editMode, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, userPermissions$lambda_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_14 = new (Separator())(element_13.get_context_h02k06_k$());
  ensureOutermostElement(element_14);
  element_13.willAddChild_hz2iwc_k$(element_14);
  element_14.onStartup_vrxh3i_k$();
  element_13.addChild_2qpft2_k$(element_14);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_19 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$76 = isInterface(tmp_19, KSerializer()) ? tmp_19 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$76);
  var tmp$ret$77 = get_managesProviders(it_1);
  var tmp_20 = lensPath(user, tmp$ret$77);
  var tmp_21 = userPermissions$lambda_8;
  var tmp_22 = userPermissions$lambda_9;
  var tmp_23 = userPermissions$lambda_10;
  var tmp_24 = userPermissions$lambda_11;
  managedEntitySection(element_13, 'Care providers', 'Edit these providers and their locations; create and edit attendance for children there. Read-only on placements, closures, and remittances.', providers, editMode, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, userPermissions$lambda_12);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_15 = new (Separator())(element_13.get_context_h02k06_k$());
  ensureOutermostElement(element_15);
  element_13.willAddChild_hz2iwc_k$(element_15);
  element_15.onStartup_vrxh3i_k$();
  element_13.addChild_2qpft2_k$(element_15);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_25 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$83 = isInterface(tmp_25, KSerializer()) ? tmp_25 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$83);
  var tmp$ret$84 = get_managesLocations(it_2);
  var tmp_26 = lensPath(user, tmp$ret$84);
  var tmp_27 = userPermissions$lambda_13;
  var tmp_28 = userPermissions$lambda_14;
  var tmp_29 = userPermissions$lambda_15;
  var tmp_30 = userPermissions$lambda_16;
  managedEntitySection(element_13, 'Locations of care', 'Edit just these locations, not the whole provider; create and edit attendance for children there. Read-only on own provider, placements, and closures.', locations, editMode, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, userPermissions$lambda_17);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_16 = new (Separator())(element_13.get_context_h02k06_k$());
  ensureOutermostElement(element_16);
  element_13.willAddChild_hz2iwc_k$(element_16);
  element_16.onStartup_vrxh3i_k$();
  element_13.addChild_2qpft2_k$(element_16);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_31 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$90 = isInterface(tmp_31, KSerializer()) ? tmp_31 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$90);
  var tmp$ret$91 = get_managesFamilies(it_3);
  var tmp_32 = lensPath(user, tmp$ret$91);
  var tmp_33 = userPermissions$lambda_18;
  var tmp_34 = userPermissions$lambda_19;
  var tmp_35 = userPermissions$lambda_20;
  var tmp_36 = userPermissions$lambda_21;
  managedEntitySection(element_13, 'Families', "Edit the family's own record; read-only on their children, attendance, placements, and supporting employers.", families, editMode, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, userPermissions$lambda_22);
  element_13.onStartup_vrxh3i_k$();
  element_9.addChild_2qpft2_k$(element_13);
  element_9.onStartup_vrxh3i_k$();
  this_9.addChild_2qpft2_k$(element_9);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function managedEntitySection(_this__u8e3s4, title, subtext_0, items, editMode, selected, idOf, display, addDescription, dialogTitle, search) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$4 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(tmp$ret$4, LabelGapSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  text(get_bold(element_0), title);
  subtext(element_0, subtext_0);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.compact' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_2 = themed(this_1, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$15 = weight(element_1, 1.0);
  var tmp0 = themed(tmp$ret$15, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.renderListIn' call
  var items_0 = items;
  var placeholdersWhileLoading = 5;
  var poolCap = 32;
  var beforeModifier = managedEntitySection$lambda;
  var render = ($this$renderListIn, item) => {
    // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
    // Inline function 'com.lightningkite.kiteui.views.important' call
    var this_0 = themed($this$renderListIn, BannerSemantic_getInstance());
    var tmp = themed(this_0, ImportantSemantic_getInstance());
    var tmp_0 = remember(VOID, VOID, VOID, VOID, ($this$remember) => display($this$remember.invoke_r7m7el_k$(item)));
    filterChip(tmp, tmp_0, editMode, managedEntitySection$lambda$slambda(selected, idOf, item));
    return Unit_instance;
  };
  var setupCalled = {_v: false};
  // Inline function 'com.lightningkite.kiteui.views.direct.rowWrapping' call
  var setup = ($this$container) => {
    setupCalled._v = true;
    renderList($this$container, items_0, placeholdersWhileLoading, poolCap, beforeModifier, render);
    return Unit_instance;
  };
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (RowWrapping())(tmp0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  tmp0.willAddChild_hz2iwc_k$(element_2);
  setup(element_2);
  element_2.onStartup_vrxh3i_k$();
  tmp0.addChild_2qpft2_k$(element_2);
  var result = element_2;
  if (!setupCalled._v) {
    var tmp = tmp0.get_context_h02k06_k$();
    var tmp_0 = Exception().new_kotlin_Exception_hsqbop_k$('renderListIn: container lambda did not call the setup lambda. Use a DSL function reference like ElementWriter::col or ElementWriter::row, or ensure your custom lambda invokes the passed setup function, e.g., { setup -> col { setup() } }');
    var tmp_1 = to('container type', toString(getKClassFromExpression(result)));
    var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(items_0.get_state_wc71uu_k$());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString(tmp0_safe_receiver);
    handleException(tmp, tmp_0, new (Metadata())(result, null, null, mapOf([tmp_1, to('items', tmp1_elvis_lhs == null ? 'NotReady' : tmp1_elvis_lhs), to('placeholders', placeholdersWhileLoading.toString()), to('poolCap', poolCap.toString())])));
  }
  var tmp_2 = get_centered(element_1);
  multiSelectAddButton(shownWhen(tmp_2, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(editMode)), addDescription, dialogTitle, selected, idOf, display, search);
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function userForm$lambda($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userNameLabel_jnppqj_k$();
}
function userForm$lambda_0($this$emailField) {
  return 'Email';
}
function userForm$lambda_1(it) {
  return new (EmailAddress())(it.email_1);
}
function userForm$lambda_2(old, new_0) {
  var tmp = new_0;
  var tmp0_elvis_lhs = tmp == null ? null : tmp.raw_1;
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new (EmailAddress())(tmp_1)) == null) {
    tmp_0 = toEmailAddress('example@example.com');
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return old.copy$default_jtwamt_k$(VOID, tmp_0);
}
function userForm$lambda_3($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userEmailLabel_3oltlg_k$();
}
function userForm$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userPhoneLabel_fdgx22_k$();
}
function userForm$lambda_5($this$invoke) {
  return 'Preferred language';
}
function addUserDialog$lambda$lambda($this$invoke) {
  return 'Add user';
}
function addUserDialog$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function addUserDialog$lambda$slambda($user, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $user.cancel_2l89ey_k$();
    $close();
    return Unit_instance;
  }), 0);
}
function addUserDialog$lambda$lambda_1($this$invoke) {
  return 'Add user';
}
function addUserDialog$lambda$slambda_0($user, $$this$with, $$this$button, $close, $clearDraft) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues($user);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* $$this$with.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      return Unit_instance;
    }
    var saved = yield* $user.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    yield* (yield* await_0(this_1, $completion)).get_users_izsycf_k$().add_co22jy_k$(saved, $completion);
    toast($$this$button.get_context_h02k06_k$(), 'User added!');
    $close();
    yield* $($clearDraft($completion), $completion);
    get_pageNavigator($$this$button.get_context_h02k06_k$()).navigate_sm5lxf_k$(new (UserDetailPage())(saved._id_1));
    return Unit_instance;
  }), 1);
}
function userPermissions$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_userRoleLabel_yi9o5y_k$();
}
function userPermissions$lambda_0(it) {
  return it.displayName_1;
}
function userPermissions$lambda_1($this$styledHeader) {
  return 'Grant type';
}
function userPermissions$lambda_2($this$styledHeader) {
  return 'Granted';
}
function userPermissions$lambda_3(it) {
  return new (ID())(it._id_1);
}
function userPermissions$lambda_4(it) {
  return it.name_1;
}
function userPermissions$lambda_5($this$managedEntitySection) {
  return 'Add employer';
}
function userPermissions$lambda_6($this$managedEntitySection) {
  return 'Employers';
}
function userPermissions$lambda_7($this$managedEntitySection, q) {
  var tmp = $this$managedEntitySection.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$4 = xDataClassPathContainsCased(get_name_0(it), $this$managedEntitySection.invoke_r7m7el_k$(q), true);
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$managedEntitySection.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function userPermissions$lambda_8(it) {
  return new (ID_0())(it._id_1);
}
function userPermissions$lambda_9(it) {
  return it.name_1;
}
function userPermissions$lambda_10($this$managedEntitySection) {
  return 'Add provider';
}
function userPermissions$lambda_11($this$managedEntitySection) {
  return 'Providers';
}
function userPermissions$lambda_12($this$managedEntitySection, q) {
  var tmp = $this$managedEntitySection.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$4 = xDataClassPathContainsCased(get_name_1(it), $this$managedEntitySection.invoke_r7m7el_k$(q), true);
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$managedEntitySection.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function userPermissions$lambda_13(it) {
  return new (ID_1())(it._id_1);
}
function userPermissions$lambda_14(it) {
  return it.name_1;
}
function userPermissions$lambda_15($this$managedEntitySection) {
  return 'Add locations of care';
}
function userPermissions$lambda_16($this$managedEntitySection) {
  return 'Locations of care';
}
function userPermissions$lambda_17($this$managedEntitySection, q) {
  var tmp = $this$managedEntitySection.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$4 = xDataClassPathContainsCased(get_name_2(it), $this$managedEntitySection.invoke_r7m7el_k$(q), true);
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$managedEntitySection.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function userPermissions$lambda_18(it) {
  return new (ID_2())(it._id_1);
}
function userPermissions$lambda_19(it) {
  return it.get_familyName_6ytaaw_k$() + ' (' + it.primaryParent_1.firstName_1 + ')';
}
function userPermissions$lambda_20($this$managedEntitySection) {
  return 'Add family';
}
function userPermissions$lambda_21($this$managedEntitySection) {
  return 'Families';
}
function userPermissions$lambda_22($this$managedEntitySection, q) {
  var tmp = $this$managedEntitySection.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$4 = or(or(xDataClassPathContainsCased(get_lastName(get_primaryParent(it)), $this$managedEntitySection.invoke_r7m7el_k$(q), true), xDataClassPathContainsCased(get_lastName(get_notNull(get_secondaryParent(it))), $this$managedEntitySection.invoke_r7m7el_k$(q), true)), xDataClassPathContainsCased(get_city(get_address(it)), $this$managedEntitySection.invoke_r7m7el_k$(q), true));
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$managedEntitySection.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function managedEntitySection$lambda($this$renderListIn) {
  return get_atCenterEnd($this$renderListIn);
}
function managedEntitySection$lambda$slambda$slambda($idOf, $item) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $item;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    return minus(it, $idOf(tmp$ret$0));
  }), 1);
}
function managedEntitySection$lambda$slambda($selected, $idOf, $item) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* modify($selected, managedEntitySection$lambda$slambda$slambda($idOf, $item), $completion);
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  addUserDialog as addUserDialog2gcyojnzrgtrb,
  userForm as userForm5nk49durav10,
  userPermissions as userPermissionskavzssr0zu9q,
};
//endregion

//# sourceMappingURL=userComponents.mjs.map
